export const ModeType = {
    Unknown: 'Unknown',
    Regular: 'Regular',
    Tiny: 'Tiny'
};